import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    buildFeaturesCountText: (count) => `${count} ${buildCorrectGrammarText(count, ["объект", "объекта", "объектов"])}`
};
